import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/logistics/v3/'

// 发货单-导出
export const exportShippingOrder = params => axios({
  url: `${commonPath}shipping/order/export`,
  responseType: "blob",
  method: 'post',
  data: params
})

// 发货单生成
export const generateShippingOrder = params => axios({
  url: `${commonPath}shipping/order`,
  method: 'post',
  data: params
})

// 发货单列表
export const getShippingOrderList = params => axios({
  url: `${commonPath}shipping/order/list`,
  method: 'post',
  data: params
})

// 发货单详情
export const getShippingDetail = id => axios({
  url: `${commonPath}shipping/order/detail/${id}`,
  method: 'get'
})

// 发货单编辑
export const editShipping = params => axios({
  url: `${commonPath}shipping/order`,
  method: 'put',
  data: params
})

// 装箱
export const shippingPacking = params => axios({
  url: `${commonPath}shipping/line/packing`,
  method: 'post',
  data: params
})

// 运单-顺丰-填单
export const shippingSfPrint = id => axios({
  url: `${commonPath}shipping/order/sf_print/${id}`,
  method: 'get'
})

// 运单-顺丰-打印
export const shippingSfDownload = id => axios({
  url: `${commonPath}shipping/order/sf_download/${id}`,
  method: 'get',
  responseType: 'blob'
})

// 发货单-打印
export const shippingPrint = id => axios({
  url: `${commonPath}shipping/order/print/${id}`,
  method: 'get'
})

// 发货单-关单-申请报关
export const placeBoe = params => axios({
  url: `${commonPath}tariff/place_boe`,
  method: 'post',
  data: params
})

// 发货项列表
export const getShippingLineList = params => axios({
  url: `${commonPath}shipping/line/list`,
  method: 'post',
  data: params
})

// 发货项-预归类
export const classifyApplies = params => axios({
  url: `rest/erp/product/v3/classify_applies`,
  method: 'post',
  data: params
})

// 发货单合并发货项
export const ShippingMerge = params => axios({
  url: `${commonPath}shipping/order/add_line`,
  method: 'post',
  data: params
})

// 发货单移出发货项
export const ShippingRemove = params => axios({
  url: `${commonPath}shipping/order/remove_line`,
  method: 'post',
  data: params
})

// 发货项详情
export const getShippingLineDetail = id => axios({
  url: `${commonPath}shipping/line/detail/${id}`,
  method: 'get'
})

// 发货单-发货项编辑
export const editShippingLine = params => axios({
  url: `${commonPath}shipping/line`,
  method: 'put',
  data: params
})

// 发货项-发货信息
export const getDeliveryInfo = id => axios({
  url: `${commonPath}shipping/line/delivery_info/${id}`,
  method: 'get'
})
